exports = module.exports = require("../../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-page{left:0;top:0;right:0;bottom:0;position:absolute;overflow:hidden;transform:translateX(-100%)}.engine-page>.engine-document{width:100%;height:100%;box-sizing:border-box;overflow:auto}.engine-page>.engine-document:after,.engine-page>.engine-document:before{content:\"\";display:table}.engine-page>.engine-document:after{clear:both}.engine-page.engine-visible{transform:translateX(0)}html.engine-design-mode .engine-page>.engine-document{padding-bottom:30px;background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/panes/workspacepane/page.less
// module id = 252
// module chunks = 0